import { PERMISSIONS } from './permissions';
import { ALL_ROLES, PORTAL_ROLES } from './roles';
import { AuthConfig } from '../types/auth';

const DASHBOARD = {
  path: '/:clientId',
  auth: { atLeast: ALL_ROLES.DASHBOARD_VIEWER },
  title: 'Dashboard',
};
const ROOT = {
  path: '/',
  exact: true,
  auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  redirect: DASHBOARD.path,
  title: 'Asseticom Dashboard',
};
const PASSWORD_RESET = {
  path: '/password-reset',
  exact: true,
  auth: { atLeast: ALL_ROLES.PUBLIC },
  title: 'Password Reset',
};
const SSO = {
  path: '/sso',
  exact: true,
  auth: { atLeast: ALL_ROLES.PUBLIC },
  title: 'SSO',
};
const ASSETICOM = {
  path: '/asseticom',
  exact: true,
  auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  title: 'Asseticom Portal',
};
const INTERNAL_TOOLS = {
  path: '/tools',
  exact: true,
  auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  title: 'Internal Tools',
};
const CLIENTS = {
  path: '/clients',
  auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  title: 'Clients',
};
const CLIENTS_ADD = {
  path: '/clients/add',
  auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  title: 'Add a Client',
};
const ADMINS = {
  path: '/admins',
  auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  title: 'Admins',
};
const ADMINS_ADD = {
  path: '/admins/add',
  auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  title: 'Add an Admin',
};
const REPORTS = {
  path: '/reports',
  auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  title: 'View Reports',
};
const USER = { path: '/user', title: 'My User Profile' };
const SURVEYS = {
  path: '/:clientId/surveys',
  auth: {
    atLeast: ALL_ROLES.SURVEYOR,
    allowedUids: PERMISSIONS.BULK_UPLOADING,
  },
  title: 'Surveys',
};
const SURVEYS_ADD = {
  path: '/:clientId/surveys/add',
  exact: true,
  auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
  title: 'Add a Survey',
};
const SURVEYS_ADD_BULK = {
  path: '/:clientId/surveys/add-bulk',
  exact: true,
  auth: {
    atLeast: ALL_ROLES.ASSETICOM_ADMIN,
    allowedUids: PERMISSIONS.BULK_UPLOADING,
  },
  title: 'Add Surveys (Bulk)',
};
const SURVEYS_REISSUE = {
  path: '/:clientId/surveys/reissue/:surveyId',
  exact: true,
  auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
  title: 'Reissue a Survey',
};
const SURVEYS_SURVEY = {
  path: '/:clientId/surveys/:surveyId',
  exact: true,
  auth: { atLeast: ALL_ROLES.VIEWER },
  title: 'Survey',
};
const SURVEYS_ROOM = {
  path: '/:clientId/surveys/:surveyId/:roomId',
  exact: true,
  auth: { atLeast: ALL_ROLES.VIEWER },
  title: 'Room',
};
const SURVEYS_ASSET = {
  path: '/:clientId/surveys/:surveyId/:roomId/:assetId',
  exact: true,
  auth: { atLeast: ALL_ROLES.VIEWER },
  title: 'Asset',
};
const SITES = {
  path: '/:clientId/sites',
  auth: {
    atLeast: ALL_ROLES.QUALITY_ASSURANCE,
    allowedUids: PERMISSIONS.BULK_UPLOADING,
  },
  title: 'Sites',
};
const SITES_ADD = {
  path: '/:clientId/sites/add',
  exact: true,
  auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
  title: 'Add a Site',
};
const SITES_ADD_BULK = {
  path: '/:clientId/sites/add-bulk',
  exact: true,
  auth: {
    atLeast: ALL_ROLES.ASSETICOM_ADMIN,
    allowedUids: PERMISSIONS.BULK_UPLOADING,
  },
  title: 'Add Sites (Bulk)',
};
const SITES_EDIT = {
  path: '/:clientId/sites/:siteId',
  exact: true,
  auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
  title: 'Site',
};
const ASSET_LISTS = {
  path: '/:clientId/asset-taxonomies',
  auth: { atLeast: ALL_ROLES.SURVEYOR },
  title: 'Taxonomies',
};
const ASSET_LISTS_ADD = {
  path: '/:clientId/asset-taxonomies/add',
  auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
  title: 'Add a Taxonomy',
};
const USERS = {
  path: '/:clientId/users',
  auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
  title: 'Users',
};
const USERS_ADD = {
  path: '/:clientId/users/add',
  auth: { atLeast: ALL_ROLES.ADMIN },
  title: 'Add a User',
};
const USERS_USER = {
  path: '/:clientId/users/:userId',
  auth: { atLeast: ALL_ROLES.ADMIN },
  title: 'User',
};
const INTERACTIVE_DASHBOARD = {
  path: '/:clientId/reporting/interactive-dashboard',
  auth: {
    atLeast: PORTAL_ROLES.DASHBOARD_VIEWER,
  },
  title: 'Interactive Dashboard Edit',
};
const REPORTING_CREATE = {
  path: '/:clientId/reporting/create',
  auth: { atLeast: ALL_ROLES.VIEWER },
  title: 'Reporting',
};

const REPORTING_VIEW = {
  path: '/:clientId/reporting',
  auth: { atLeast: ALL_ROLES.VIEWER },
  title: 'Reporting History',
};

const ASSET_DATA_IMPORT = {
  path: '/:clientId/asset-data-import',
  auth: { atLeast: ALL_ROLES.SURVEYOR },
  title: 'Asset Data Import',
};
const SETTINGS = {
  path: '/:clientId/settings',
  auth: { atLeast: ALL_ROLES.ADMIN },
  title: 'Settings',
};
const NOT_FOUND = { path: '/not-found', title: 'Page Not Found' };
const LOGIN = { path: '/login', exact: true, title: 'Log in to Asseticom' };
const NOT_AUTHED = { path: '/not-authed', title: 'Not Authed' };
const QR_CODE_NOT_FOUND = {
  path: '/qr-not-found',
  title: 'QR Code Not Found',
};
const TOOLS = { path: '/:clientId/tools', title: 'Tools' };
const CROPPER = { path: '/:clientId/tools/cropper', title: 'Cropper Tool' };

export const ROUTES_MAP = {
  ROOT,
  ASSETICOM,
  INTERNAL_TOOLS,
  LOGIN,
  PASSWORD_RESET,
  SSO,
  QR_CODE_NOT_FOUND,
  NOT_AUTHED,
  CLIENTS,
  CLIENTS_ADD,
  ADMINS,
  ADMINS_ADD,
  REPORTS,
  USER,
  DASHBOARD,
  SURVEYS,
  SURVEYS_ADD,
  SURVEYS_ADD_BULK,
  SURVEYS_REISSUE,
  SURVEYS_SURVEY,
  SURVEYS_ROOM,
  SURVEYS_ASSET,
  SITES,
  SITES_ADD,
  SITES_ADD_BULK,
  SITES_EDIT,
  ASSET_LISTS,
  ASSET_LISTS_ADD,
  USERS,
  USERS_ADD,
  USERS_USER,
  INTERACTIVE_DASHBOARD,
  REPORTING_CREATE,
  REPORTING_VIEW,
  ASSET_DATA_IMPORT,
  SETTINGS,
  NOT_FOUND,
  TOOLS,
  CROPPER,
} as const;

type RouteProps = {
  path: string;
  auth?: AuthConfig;
  exact?: boolean;
  redirect?: string;
};

type NavRoutesMapProps = Record<keyof typeof ROUTES_MAP, RouteProps>;

// remove the :clientId as this is added dynamically in the nav menu component
export const NAV_ROUTES_MAP: NavRoutesMapProps = Object.keys(ROUTES_MAP).reduce(
  (accumulator, route) => {
    accumulator[route] = {
      ...ROUTES_MAP[route],
      path: ROUTES_MAP[route].path.replace('/:clientId', ''),
    };
    return accumulator;
  },
  { ...ROUTES_MAP },
);

type RouteConfigItem = {
  text: string;
  path: string;
  icon: string;
  auth?: AuthConfig;
  accessibleText?: string;
};

type AsseticomRouteConfigProps = {
  subHeading?: string;
  items: RouteConfigItem[];
  auth?: AuthConfig;
}[];

export const asseticomRouteConfig: AsseticomRouteConfigProps = [
  {
    subHeading: 'Portals',
    items: [
      {
        text: 'Dashboard',
        path: NAV_ROUTES_MAP.ROOT.path,
        icon: 'dashboard',
        accessibleText: 'View Dashboard',
      },
      {
        text: 'View',
        path: NAV_ROUTES_MAP.CLIENTS.path,
        icon: 'view-portals',
        accessibleText: 'View Portals',
      },
      {
        text: 'Add',
        path: NAV_ROUTES_MAP.CLIENTS_ADD.path,
        icon: 'add-new',
        accessibleText: 'Add Portal',
      },
    ],
    auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  },
  {
    subHeading: 'People',
    items: [
      {
        text: 'View',
        path: NAV_ROUTES_MAP.ADMINS.path,
        icon: 'view-users',
        accessibleText: 'View Users',
      },
      {
        text: 'Add',
        path: NAV_ROUTES_MAP.ADMINS_ADD.path,
        icon: 'add-new',
        accessibleText: 'Add User',
      },
    ],
    auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  },
  {
    subHeading: 'Reports',
    items: [
      {
        text: 'View',
        path: NAV_ROUTES_MAP.REPORTS.path,
        icon: 'dashboard',
        accessibleText: 'View Users',
      },
    ],
    auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  },
  {
    subHeading: 'Tools',
    items: [
      {
        text: 'View',
        path: NAV_ROUTES_MAP.INTERNAL_TOOLS.path,
        icon: 'cut',
        accessibleText: 'View Tools',
      },
    ],
    auth: { atLeast: ALL_ROLES.ASSETICOM_ADMIN },
  },
];

type ClientRouteConfigProps = {
  subHeading?: string;
  items: RouteConfigItem[];
  auth?: AuthConfig;
}[];

export const clientRouteConfig: ClientRouteConfigProps = [
  {
    subHeading: 'Your Portal',
    items: [
      {
        text: 'Dashboard',
        path: NAV_ROUTES_MAP.DASHBOARD.path,
        icon: 'dashboard',
        accessibleText: 'View Dashboard',
      },
    ],
  },
  {
    subHeading: 'Sites & Buildings',
    auth: {
      atLeast: ALL_ROLES.QUALITY_ASSURANCE,
      allowedUids: PERMISSIONS.BULK_UPLOADING,
    },
    items: [
      {
        text: 'Add',
        path: NAV_ROUTES_MAP.SITES_ADD.path,
        icon: 'add-new',
        accessibleText: 'Add Sites & Buildings',
        auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
      },
      {
        text: 'Add (Bulk)',
        path: NAV_ROUTES_MAP.SITES_ADD_BULK.path,
        icon: 'add-new',
        auth: {
          atLeast: ALL_ROLES.ASSETICOM_ADMIN,
          allowedUids: PERMISSIONS.BULK_UPLOADING,
        },
        accessibleText: 'Add Sites & Buildings (Bulk)',
      },
      {
        text: 'View',
        path: NAV_ROUTES_MAP.SITES.path,
        icon: 'building',
        accessibleText: 'View Sites & Buildings',
      },
    ],
  },
  {
    subHeading: 'Surveys',
    auth: { atLeast: ALL_ROLES.SURVEYOR },
    items: [
      {
        text: 'Add',
        path: NAV_ROUTES_MAP.SURVEYS_ADD.path,
        icon: 'add-new',
        auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
        accessibleText: 'Add Survey',
      },
      {
        text: 'Add (Bulk)',
        path: NAV_ROUTES_MAP.SURVEYS_ADD_BULK.path,
        icon: 'add-new',
        auth: {
          atLeast: ALL_ROLES.ASSETICOM_ADMIN,
          allowedUids: PERMISSIONS.BULK_UPLOADING,
        },
        accessibleText: 'Add Surveys (Bulk)',
      },
      {
        text: 'View',
        path: NAV_ROUTES_MAP.SURVEYS.path,
        icon: 'edit',
        auth: { atLeast: ALL_ROLES.SURVEYOR },
        accessibleText: 'View Surveys',
      },
    ],
  },
  {
    subHeading: 'Asset Taxonomies',
    auth: { atLeast: ALL_ROLES.QUALITY_ASSURANCE },
    items: [
      {
        text: 'Add',
        path: NAV_ROUTES_MAP.ASSET_LISTS_ADD.path,
        icon: 'add-new',
        accessibleText: 'Add Asset Taxonomy',
        auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
      },
      {
        text: 'View',
        path: NAV_ROUTES_MAP.ASSET_LISTS.path,
        icon: 'document',
        accessibleText: 'View Asset Taxonomies',
      },
    ],
  },
  {
    subHeading: 'Reporting',
    items: [
      {
        text: 'Interactive Dashboard',
        path: NAV_ROUTES_MAP.INTERACTIVE_DASHBOARD.path,
        icon: 'chart',
        auth: {
          atLeast: ALL_ROLES.DASHBOARD_VIEWER,
        },
        accessibleText: 'Interactive Dashboard',
      },
      {
        text: 'Create',
        path: NAV_ROUTES_MAP.REPORTING_CREATE.path,
        icon: 'add-new',
        auth: { atLeast: ALL_ROLES.VIEWER },
        accessibleText: 'Create a Report',
      },
      {
        text: 'View',
        path: NAV_ROUTES_MAP.REPORTING_VIEW.path,
        icon: 'document',
        auth: { atLeast: ALL_ROLES.VIEWER },
        accessibleText: 'View reports history',
      },
      {
        text: 'Import',
        path: NAV_ROUTES_MAP.ASSET_DATA_IMPORT.path,
        icon: 'import',
        auth: { atLeast: ALL_ROLES.SURVEYOR },
        accessibleText: 'Import Asset Data',
      },
    ],
  },
  {
    subHeading: 'Users',
    auth: { atLeast: ALL_ROLES.LEAD_SURVEYOR },
    items: [
      {
        text: 'Add',
        path: NAV_ROUTES_MAP.USERS_ADD.path,
        icon: 'add-new',
        auth: { atLeast: ALL_ROLES.ADMIN },
        accessibleText: 'Add User',
      },
      {
        text: 'View',
        path: NAV_ROUTES_MAP.USERS.path,
        icon: 'view-users',
        auth: { atLeast: ALL_ROLES.SURVEYOR },
        accessibleText: 'View Users',
      },
      // {
      //   text: 'Settings',
      //   path: NAV_ROUTES_MAP.SETTINGS.path,
      //   icon: 'settings',
      //   auth: ALL_ROLES.ADMIN,
      //   accessibleText: 'User Settings',
      // },
    ],
  },
  {
    subHeading: 'Help',
    auth: { atLeast: ALL_ROLES.VIEWER },
    items: [
      {
        text: 'Help',
        path: 'https://support.asseticom.co.uk/en/',
        icon: 'help',
        auth: { atLeast: ALL_ROLES.VIEWER },
        accessibleText: 'Help',
      },
    ],
  },
  {
    subHeading: 'Tools',
    auth: { atLeast: ALL_ROLES.SURVEYOR },
    items: [
      {
        text: 'Cropper',
        path: NAV_ROUTES_MAP.CROPPER.path,
        icon: 'cut',
        auth: { atLeast: ALL_ROLES.SURVEYOR },
        accessibleText: 'Cropper Tool',
      },
    ],
  },
];
